var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5823 8.55469L20.3167 6.67969V2.92969C20.3167 2.77344 20.1604 2.61719 20.0042 2.61719H18.7542C18.5588 2.65625 18.4417 2.77344 18.4417 2.92969V5.15625L12.9338 0.625C12.5823 0.3125 12.0745 0.15625 11.5667 0.15625C11.0198 0.15625 10.512 0.3125 10.1604 0.625L0.511963 8.55469C0.394775 8.67188 0.31665 8.82812 0.31665 9.02344C0.31665 9.17969 0.355713 9.33594 0.433838 9.41406L0.863525 9.92188C0.94165 10.0391 1.13696 10.1172 1.33228 10.1172C1.48853 10.1172 1.60571 10.0781 1.7229 10L2.81665 9.10156V16.3672C2.81665 17.0703 3.36353 17.6172 4.06665 17.6172H9.06665C9.73071 17.6172 10.2776 17.0703 10.3167 16.3672V12.3047H12.8167V16.3672C12.8167 17.0703 13.3635 17.6172 14.0667 17.6172H19.0667C19.7307 17.6172 20.2776 17.0703 20.3167 16.4062V9.10156L21.3713 10C21.4885 10.0781 21.6057 10.1562 21.762 10.1562C21.9573 10.1562 22.1526 10.0391 22.2698 9.92188L22.6604 9.41406C22.7385 9.33594 22.8167 9.17969 22.8167 9.02344C22.8167 8.82812 22.6995 8.67188 22.5823 8.55469ZM18.4026 15.7422H14.6917V11.6797C14.6526 11.0156 14.1057 10.4688 13.4417 10.4297H9.69165C8.98853 10.4688 8.44165 11.0156 8.44165 11.6797V15.7422H4.69165V7.57812L11.5667 1.91406L18.4417 7.57812L18.4026 15.7422Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayHomeIcon);
export default __webpack_public_path__ + "static/media/gray_home_icon.3c26c6ce4fa3e6f76a62295afbed73f5.svg";
export { ForwardRef as ReactComponent };